import styled from 'styled-components'

export const Container = styled.div`
    padding: 100px 50px;
    text-align: center;
    background-color: #fff;
`

export const Texto = styled.div`
    text-align: center;
    color: var(--color-gray-1);
    font-size: 0.9em;
    margin-top: 5px;
`